import { render, staticRenderFns } from "./ExtendedAbout.vue?vue&type=template&id=ffd801be&"
import script from "./ExtendedAbout.vue?vue&type=script&lang=js&"
export * from "./ExtendedAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports